export const handleKeyDownInput = (e, selectorRef) => {
  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
    e.view.event.preventDefault();
  }
  if (selectorRef.current) {
    const length = selectorRef.current.childNodes.length;

    if (e.key === 'ArrowDown') {
      return selectorRef.current.childNodes[0].focus();
    } else if (e.key === 'ArrowUp') {
      return selectorRef.current.childNodes[length - 1].focus();
    }
  }
};

export const handleKeyDownSelect = (e, selectorRef, inputRef) => {
  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
    e.view.event.preventDefault();
  }
  if (selectorRef.current) {
    const index = Array.prototype.indexOf.call(
      selectorRef.current.childNodes,
      e.target
    );
    const length = selectorRef.current.childNodes.length;

    if (e.key === 'ArrowDown') {
      if (index >= length - 1) {
        return inputRef.current.childNodes[1].focus();
      }
      selectorRef.current.childNodes[index + 1].focus();
    } else if (e.key === 'ArrowUp') {
      if (index <= 0) {
        return inputRef.current.childNodes[1].focus();
      }
      return selectorRef.current.childNodes[index - 1].focus();
    }
  }
};
